<template>
  <div
    class="dropdown-component"
    :style="{ color: $store.registratorTextTop }"
    @click="switchOpenState()"
  >
    <div
      class="selected-option"
      :style="{ backgroundColor: $store.registratorBackgroundTopColor }"
    >
      <p>
        {{ selectedItem.tag }}
      </p>
      <svg
        class="select-arrow"
        :class="{ 'select-arrow_open': isOpen }"
        width="25"
        height="12"
        viewBox="0 0 25 12"
        fill="none"
      >
        <path
          d="M12 12L0 0H24L12 12Z"
          :fill="$store.registratorTextTop"
        />
      </svg>
    </div>

    <ul
      v-if="isOpen"
      class="options"
      :style="{ backgroundColor: $store.registratorBackgroundTopColor }"
    >
      <li
        v-for="language in options"
        :key="language.tag"
        class="dropdown-item"
        @click="selectItem(language)"
      >
        {{ language.tag }}
      </li>
    </ul>
    <div
      v-if="isOpen"
      class="wrapper"
    />
  </div>
</template>

<script>
export default {
  name: 'LanguageDropdown',
  props: {
    languages: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedItem: {
      type: Object,
      default() {
        return this.languages[0];
      },
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    options() {
      return this.languages.filter(item => item !== this.selectedItem);
    }
  },
  methods: {
    selectItem(item) {
      this.$emit('selectItem', item);
    },
    switchOpenState() {
      this.isOpen = !this.isOpen;
      this.$emit('changeOpen', this.isOpen);
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
}

.dropdown-component {
  position: relative;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 30px;

  .selected-option {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    z-index: 3;

    p {
      margin-right: 12px;
    }

    .select-arrow {
      &_open {
        transform: rotate(180deg);
      }
    }
  }

  .options {
    width: 100%;
    position: absolute;
    top: 100%;
    z-index: 4;
    margin-top: -1px;

    .dropdown-item {
      height: 100px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.wrapper {
  position: fixed;
  top: auto;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--label-secondary);
  z-index: 3;
}

@media screen and(max-width: 645px) {
  .dropdown-component .options .dropdown-item {
    height: 80px;
  }
  .select-arrow {
    width: 18px;
  }
  .dropdown-component .selected-option p {
    margin: 8px;
  }
}
</style>
